export { Icons } from './common-icons';
export * from './dignity-icons';
export * from './clinics-icons';
